import React, { useContext } from "react";
import { MainNav } from "./MainNav";
import AppContext from "../../context/AppContext";
import { useLocation } from "react-router-dom";
import HeaderNavBar from "./HeaderNavbar";
import PageCard from "../common/PageCard";

export const Layout = ({ children }) => {
  const { theme } = useContext(AppContext);
  const location = useLocation();
  const isMapTaskPage = location.pathname === "/maptask";
  const isTaskManagePage = location.pathname === "/task-manage";
  const isImportCsvPage = location.pathname === "/task/import-csv";
  const isRoleManagementPage = location.pathname === "/role-management";
  const isUserManagementPage = location.pathname === "/all-users";
  const isConfigurationPage = location.pathname === "/configuration";
  const isExportReportPage = location.pathname === "/export-report-and-data";
  const isReportsPage = location.pathname === "/reports";
  const isStockManagementPage = location.pathname === "/stock-managment";
  const isInventoryManagementPage =
    location.pathname === "/inventory-management";
  const isSecurityPage =
    location.pathname === "/security" ||
    location.pathname === "/security/protection-jobs";
  const isOrganizationPage = location.pathname === "/organization";
  const isWorklogPage = location.pathname === "/worklog";
  const isPdfGeneratorPage = location.pathname === "/pdf-generator";
  const isPdfExportHistoryPage = location.pathname === "/pdf-export-history";
  const isWorkflowPage = location.pathname === "/workflow";
  const isCustomerSupportPage = location.pathname === "/customer-support";
  const isAppUpdateConfigPage = location.pathname === "/app-update-config";

  const isFixedTaskPage =
    isTaskManagePage ||
    isImportCsvPage ||
    isRoleManagementPage ||
    isUserManagementPage ||
    isConfigurationPage ||
    isExportReportPage ||
    isOrganizationPage ||
    isReportsPage ||
    isStockManagementPage ||
    isInventoryManagementPage ||
    isSecurityPage ||
    isWorklogPage ||
    isPdfGeneratorPage ||
    isPdfExportHistoryPage ||
    isWorkflowPage ||
    isCustomerSupportPage ||
    isAppUpdateConfigPage;
  return (
    <div
      className={`flex flex-col sm:flex-row h-screen min-h-[100dvh] max-h-[100dvh] w-full max-w-full overflow-hidden ${
        theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : theme === "light" && "bg-gray-50 "
      } bg-gray-100 relative`}
    >
      <HeaderNavBar />
      <div
        className={` ${
          theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : theme === "light" && "bg-gray-50 "
        } flex flex-col flex-1 min-w-0 max-w-full w-full sm:w-auto p-2 sm:p-3 lg:p-[14px] gap-2 h-full min-h-0 overflow-hidden`}
      >
        <MainNav />
        <main
          className={`bg-white flex-1 min-h-0 min-w-0 max-w-full !rounded-[16px] border border-gray-200/50 shadow-sm ${
            theme === "dark"
              ? "dark-mode"
              : theme === "high-contrast"
                ? "high-contrast"
                : theme === "light" && ""
          } ${
            isMapTaskPage || isImportCsvPage || isSecurityPage
              ? "!overflow-hidden"
              : isFixedTaskPage
                ? "overflow-y-auto sm:!overflow-hidden"
                : "overflow-y-auto"
          } overflow-x-hidden`}
        >
          <div
            className={`${isMapTaskPage || isFixedTaskPage ? "h-full min-h-0" : "min-h-full"} w-full min-w-0 max-w-full rounded-[16px] bg-white ${
              theme === "dark"
                ? "dark-mode"
                : theme === "high-contrast"
                  ? "high-contrast"
                  : theme === "light" && ""
            }`}
          >
            <PageCard>{children}</PageCard>
          </div>
        </main>
      </div>
    </div>
  );
};
